import { useEffect, useState } from 'react';
import { textos } from '../textos';
import { elegirEmpresa, listarEmpresas, type EmpresaDeSesion, type SesionMe } from '../features/session/api';

export function SelectorEmpresa(props: { readonly sesion: SesionMe }): React.JSX.Element | null {
  const [empresas, setEmpresas] = useState<readonly EmpresaDeSesion[]>([]);

  useEffect(() => {
    void listarEmpresas()
      .then(setEmpresas)
      .catch(() => undefined);
  }, [props.sesion]);

  if (empresas.length < 2) {
    return <p className="truncate text-sm font-medium text-brand-text">{props.sesion.company?.name}</p>;
  }

  return (
    <label className="flex min-w-0 items-center gap-2 text-sm text-brand-text-muted">
      {textos.sesion.cambiarEmpresa}
      <select
        className="min-h-tactil min-w-[10rem] rounded-brand border border-brand-border bg-brand-surface px-2 font-medium text-brand-text"
        value={props.sesion.company?.id ?? ''}
        onChange={(ev) => {
          const id = ev.target.value;
          if (!id || id === props.sesion.company?.id) return;
          void elegirEmpresa(id, props.sesion.csrfToken).then(() => {
            window.location.reload();
          });
        }}
      >
        {empresas.map((e) => (
          <option key={e.id} value={e.id}>
            {e.name}
          </option>
        ))}
      </select>
    </label>
  );
}
